module.exports = __webpack_public_path__ + "static/media/logoUport.d1ac25e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/logoUport.png
// module id = 775
// module chunks = 1 3